module.exports = __webpack_public_path__ + "img/no-package.dad809a8.png";